import { create } from 'zustand';

type KnowledgeSettingsTabStore = {
  isEditModalOpen: boolean;
  editName: string;
  editDescription: string;
  editIcon: string;
  openEditModal: (values: {
    name: string;
    description: string;
    icon: string;
  }) => void;
  closeEditModal: () => void;
  setEditName: (name: string) => void;
  setEditDescription: (description: string) => void;
  setEditIcon: (icon: string) => void;
  reset: () => void;
};

const initialEditState = {
  isEditModalOpen: false,
  editName: '',
  editDescription: '',
  editIcon: '',
};

export const useKnowledgeSettingsTabStore = create<KnowledgeSettingsTabStore>(
  (set) => ({
    ...initialEditState,
    openEditModal: ({ name, description, icon }) =>
      set({
        isEditModalOpen: true,
        editName: name,
        editDescription: description,
        editIcon: icon,
      }),
    closeEditModal: () => set({ isEditModalOpen: false }),
    setEditName: (editName) => set({ editName }),
    setEditDescription: (editDescription) => set({ editDescription }),
    setEditIcon: (editIcon) => set({ editIcon }),
    reset: () => set(initialEditState),
  }),
);
